/**
 * ActionPanel - 功能入口区
 * 
 * 职责：
 * - 提供折扣码输入入口
 * - 提供购物车详情页入口
 * - 次级操作按钮组
 * 
 * 设计原则：
 * - 轻量化，只提供入口
 * - 通过回调处理点击
 * - 使用意大利语文案
 * - 统一 Ghost 按钮样式
 */

import { ArrowRight } from 'lucide-react';


interface ActionPanelProps {
    onDiscountClick?: () => void;
    onCartDetailClick?: () => void;
    showDiscount?: boolean;
    showCartDetail?: boolean;
}

/**
 * 购物车操作入口面板，提供折扣码和详情页两个按钮入口。
 * @param onDiscountClick 点击折扣码按钮的回调
 * @param onCartDetailClick 点击详情按钮的回调
 * @param showDiscount 是否展示折扣按钮
 * @param showCartDetail 是否展示详情按钮
 */
export function ActionPanel({
    onDiscountClick,
    onCartDetailClick,
    showDiscount = true,
    showCartDetail = true,
}: ActionPanelProps) {
    // 如果两个按钮都不显示，返回 null
    if (!showDiscount && !showCartDetail) return null;

    return (
        <div className="mt-4 flex justify-between items-center text-sm">
            {/* 折扣码入口 */}
            {showDiscount && onDiscountClick && (
                <button
                    onClick={onDiscountClick}
                    className="text-gray-500 hover:text-gray-900 underline decoration-gray-300 underline-offset-4"
                >
                    Codice sconto
                </button>
            )}

            {/* 购物车详情页入口 */}
            {showCartDetail && onCartDetailClick && (
                <button
                    onClick={onCartDetailClick}
                    className="flex items-center gap-1 text-gray-900 font-medium hover:gap-2 transition-all"
                >
                    Vedi carrello <ArrowRight size={16} />
                </button>
            )}
        </div>
    );
}
